import { createBrowserRouter } from "react-router-dom"
import Login from '../views/Login'
import Barcode from '../views/Barcode'
import Dashboard from '../views/Dashboard'
import ResetPassword from '../views/ResetPassword'
import PrintWaveForm from '../views/Print/waveForm'
import PrintTrend from '../views/Print/trendForm'
import PrintAlarm from '../views/Print/alarmForm'
import PrintLead from '../views/Print/leadForm'
import PrintBarcodeForm from '../views/Print/barcodeForm'
import Printv20Form from '../views/Print/v20Form'
import Printv20TrendForm from '../views/Print/v20TrendForm'
import AdminLogin from '../views/Admin/Login'
import Adminchangepwd from '../views/Admin/ChangePwd'
import AdminMain from '../views/Admin/Main'

const router = createBrowserRouter([
    {
        path: '/dashboard',
        element: <Dashboard />
    },
    {
        path: '/resetPassword',
        element: <ResetPassword />
    },      
    {
        path: '/barcode',
        element: <Barcode />
    },
    {
        path: '/',
        element: <Login />
    },
    {
        path: '/print',        
        children: [
            {
                path: 'waveform',
                element: <PrintWaveForm />
            },
            {
                path: 'trendform',
                element: <PrintTrend />
            },
            {
                path: 'alarmform',
                element: <PrintAlarm />
            },
            {
                path: 'leadform',
                element: <PrintLead />
            },
            {
                path: 'barcodeform',
                element: <PrintBarcodeForm />
            },
            {
                path : 'v20form',
                element : <Printv20Form />
            },
            {
                path : 'v20trendform',
                element : <Printv20TrendForm />
            }
        ]
    },
    {
        path: '/admin',        
        children: [
            {
                index: true,
                element: <AdminLogin />
            },
            {
                path: 'changepwd',
                element: <Adminchangepwd />
            },
            {
                path: 'main',
                element: <AdminMain />
            }
        ]
    },
])

export default router